import apiService from '@/services/apiService';

const actions = {
  getBeforeSending({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxel-recycle/before-sending`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postBeforeSending({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/before-sending', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
